import omniSegmentService from './reducers';

import * as omniSegmentOperation from './operation';
import * as omniSegmentType from './types';
import * as omniSegmentAction from './actions';

export { omniSegmentOperation, omniSegmentType, omniSegmentAction };

export default omniSegmentService;
